export const Sdata=[
    {
        id:"1",
        title:"Transport",
        things:"0 things to do"
    },
    {
        id:"2",
        title:"Classes & workshops",
        things:"0 things to do"
    },
    {
        id:"3",
        title:"Wildlife & nature",
        things:"0 things to do"
    },
    {
        id:"4",
        title:"History & culture",
        things:"13 things to do"
    }
   

]